import nBossConnection from 'modules/base/service/nBossConnection';
import EntityValidationResult from 'modules/base/dto/validation/EntityValidationResult';
import MeasurementEditDto from '../dto/MeasurementEditDto';

class MeasurementEditService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'measurementEditControl';
	}

	/**
	 * @return {Promise<MeasurementEditDto>}
	 */
	create() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/create`)
				.then(response => resolve(new MeasurementEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @return {Promise<MeasurementEditDto>}
	 */
	getData(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getData`, {
					id
				})
				.then(response => resolve(new MeasurementEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {MeasurementEditDto} dto
	 * @return {Promise<EntityValidationResult>}
	 */
	save(dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/save`, {
					dto
				})
				.then(response => resolve(new EntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @return {Promise<Object>}
	 */
	getFormData() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/getFormData`)
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @param {ProjectEditDto} dto
	 * @return {Promise<EntityValidationResult>}
	 */
	update(id, dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/update`, {
					id,
					dto
				})
				.then(response => resolve(new EntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @return {Promise<boolean>}
	 */
	isDone(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/isDone`, { id })
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @return {Promise<number>}
	 */
	getDeviceExternalId(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getDeviceExternalId`, { id })
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @return {Promise<Object>}
	 */
	stopRecordingSubmitted(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/stopRecordingSubmitted`, { id })
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @return {Promise<Object>}
	 */
	startRecording(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/startRecording`, { id })
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @return {Promise<Object>}
	 */
	startMeasuring(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/startMeasuring`, { id })
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @return {Promise<Object>}
	 */
	stop(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/stop`, { id })
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}
}

export default new MeasurementEditService();
